import React from 'react';

import { makeStyles, useTheme } from "@material-ui/core/styles";

import Grid from '@material-ui/core/Grid';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import CeremonyBuilder from './CeremonyBuilder/Builder';


const useStyles = makeStyles(theme => ({
    dialogContent: {
        backgroundColor: theme.palette.grey[200],
    },
    compact: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    backToTop: {
        position: 'absolute',
        left: 15,
        color: theme.palette.primary.main
    },
}));


const CeremonyBuilderDialog = (props) => {
    const {
        open,
        handleClose,
        scroll,
        couple,
    } = props;

    const classes = useStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const scrollToTop = () => {
        document.getElementById('ceremony-builder-top').scrollIntoView();
    }

    const coupleName = couple ? `${couple.bride_full_name} and ${couple.groom_full_name}` : '';
    const [showProgress, setShowProgress] = React.useState(false);
    const [showSuccess, setShowSuccess] = React.useState(false);

    const sendToCouple = () => {
        setShowProgress(true);
        const data = {
            _token: window._token,
        };
        const url = `/api/couples/${couple.id}/send-ceremony-to-couple`;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .then(result => {
                setShowProgress(false);
                setShowSuccess(true);
                setTimeout(() => {
                    setShowSuccess(false);
                }, 2000);
            })
            .catch(reason => {
                setShowProgress(false);
                alert('An error prevented sending the email. Please refresh the page and try again.');
            });
    }

    return (
        <React.Fragment>
            {open && couple && (
                <Dialog
                    open={open}
                    onClose={handleClose}
                    scroll={scroll}
                    maxWidth="lg"
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    fullScreen
                >
                    <DialogTitle
                        id="scroll-dialog-title"
                        className={classes.dialogTitle}
                    >
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                        >
                            <Grid item>
                                {`Ceremony Builder for: ${coupleName}`}
                            </Grid>
                            <Grid item>
                                <Button
                                    onClick={sendToCouple}
                                    color="inherit"
                                    variant="outlined"
                                    disabled={showProgress}
                                    endIcon={showProgress ? <CircularProgress color="inherit" size={20} /> : (showSuccess ? <CheckIcon /> : null)}
                                >
                                    Send to couple
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'} className={classes.dialogContent}>
                        <DialogContentText component="div" className={classes.compact}>
                            <CeremonyBuilder id={couple.id} setOuterEditing={() => {}} />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={scrollToTop} className={classes.backToTop}>
                            Back to top
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </React.Fragment>
    )
}

export default CeremonyBuilderDialog;
